import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles({
  filter: {
    marginTop: '1rem',
  },
})
